export default __webpack_public_path__ + "static/media/votizlove.5b65a9b4.png";